import { InboxNotificationDetailsResponse } from 'src/entities/Notifications';
import { API } from 'src/utils/AmplifyApiUtils';

const REQUEST_LIMIT = 1000;

export default class InboxClient {
  static async loadPaginatedNotifications(
    notifications: InboxNotificationDetailsResponse[],
    pagesToLoad = Infinity,
    nextToken: string | undefined = undefined,
  ): Promise<InboxNotificationDetailsResponse[]> {
    const getNotificationsResponse = await API.get('AppAPI', `/notifications`, {
      queryStringParameters: {
        nextToken,
        limit: REQUEST_LIMIT,
      },
    });

    const allNotifications = [
      ...notifications,
      ...(getNotificationsResponse.data ?? []),
    ];

    if (pagesToLoad <= 1 || !getNotificationsResponse.nextToken) {
      return allNotifications;
    }

    return this.loadPaginatedNotifications(
      allNotifications,
      pagesToLoad - 1,
      getNotificationsResponse.nextToken,
    );
  }
}
